import { useNavigate, useLocation } from "react-router-dom";
import UserProfileDropdown from "./UserProfileDropDown";
import { useSelector } from "react-redux";

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state) => state.user.user);

  const navItems = [
    { label: "Dashboard", path: "/" },
    { label: "News Feed", path: "/newsfeed" },
    { label: "Tasks", path: "/tasks" },
    { label: "Locations", path: "/locations" },
    { label: "People", path: "/people" },
    { label: "Schedule", path: "/schedule" },
    { label: "Timesheets", path: "/approve" },
    { label: "Reports", path: "/reports" },
  ];

  return (
    <div className="fixed top-0 left-0 right-0 bg-white z-50 shadow">
      <nav
        className="flex items-center justify-between lg:px-4"
        aria-label="Global"
      >
        <div className="flex gap-x-2">
          <div className="px-4 text-2xl text-red-700 font-bold flex text-center justiy-center items-center">
            Alertline Roster
          </div>
          {navItems.map(({ label, path }) => {
            const isActive = location.pathname === path;

            return (
              <div
                key={path}
                onClick={() => navigate(path)}
                className={`text-sm cursor-pointer p-4 hover:bg-[#e1e1e1] ${
                  isActive
                    ? "text-[#1E163C] border-b-[3px] border-[#1E163C] font-bold"
                    : "text-gray-900 font-sm"
                }`}
              >
                {label}
              </div>
            );
          })}
        </div>
        {user !== null && (
          <div className="flex justify-center items-center p-2 hover:bg-[#e1e1e1]">
            <UserProfileDropdown user={user} />
          </div>
        )}
      </nav>
    </div>
  );
}
